import { render } from "./BannerListing.vue?vue&type=template&id=56546bca&ts=true"
import script from "./BannerListing.vue?vue&type=script&lang=ts"
export * from "./BannerListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__